import { connect } from 'react-redux'
import { PANTALLA_ANTERIOR_ID, PANTALLA_INDICE_ID, PANTALLA_LIBRO_ID, selectors, actions } from 'ibook-api'
import { PantallaIndice } from 'ibook-api'

import Contenedores from './contenedores'

const PantallaIndiceFlipped = connect(
    (state, ownProps) => {
        const pantallaProps = selectors.getPantallaProps(state)
        const libroId = ownProps.libroId || pantallaProps.libroId
        const configIndice =  selectors.getConfigIndice(state, libroId) || { unidades: [] }
        return {
            libroId, 
            configIndice,
            Contenedores
        }
    },
    (dispatch, ownProps) => ({   
        onZona: (libroId, numPagina, numZona) => dispatch(actions.zona(libroId, numPagina, numZona)),
        onPagina: (libroId, numPagina) => dispatch(actions.pantalla(PANTALLA_LIBRO_ID, {libroId, numPagina})),
        onIndice: (libroId) => dispatch(actions.pantalla(PANTALLA_INDICE_ID, {libroId})),
        onPantalla: (pantallaId, props) => dispatch(actions.pantalla(pantallaId, props)),
        onAtras: () => dispatch(actions.pantalla(PANTALLA_ANTERIOR_ID))
    })
)(PantallaIndice.Pantalla)

export default PantallaIndiceFlipped